import { Fetcher } from "@/utils/fetcher";
import { AxiosRequestConfig } from "axios";

const brand = new Fetcher('brand');
const product = new Fetcher('product');
brand.setUseToken(false);

// get brand by slug
export const getBrandBySlug = (slug: string) =>
    brand.get<BrandItem>(`/storefront/get-one/${slug}`);

// get brand by ids
export const getBrandsByIds = (ids: number[]) =>
    brand.post<BrandItem []>('/storefront/get-brands-by-ids', { ids });

// get all brands by filter
// {{apiUrl}}/api/v1/brand/storefront/get-all?perPage&currentPage&search&isFeatured&category=samsung
interface GetAllBrandsRequest extends Pagination {
    isFeatured?: boolean;
    category?: string;
    sortBy: "id" | "serial_no";
    sortOrder: "ASC" | "DESC";
    config?: AxiosRequestConfig<any>;
}
export const getAllBrands = ({ config, ...data }: GetAllBrandsRequest) =>
    brand.get<BrandResponse>(`/storefront/get-all?${brand.buildQuery(data)}`, config);

// brands by category: /product/storefront/brands-by-category/:slug?perPage=15&currentPage=1
export const getBrandsByCategory = (categorySlug: string, queryData: GetAllBrandsRequest) => 
    product.get<BrandResponse>(`/storefront/brands-by-category/${categorySlug}?${product.buildQuery(queryData)}`);